// The value a slider position represents. Extracted so it can be tested
// without a gesture; marked as a worklet so the pan handler can call it.
export function sliderValueForStep(
  stepIndex: number,
  min: number,
  max: number,
  step: number
): number {
  'worklet';
  // stepIndex * step is an offset from min, so it clamps against the span
  // rather than against min and max.
  const span = max - min;
  let offset = stepIndex * step;
  if (offset < 0) {
    offset = 0;
  } else if (offset > span) {
    offset = span;
  }
  return offset + min;
}
